module.exports = __webpack_public_path__ + "static/media/3.28ba6af5.jpg";